module.exports = __webpack_public_path__ + "img/send_list.873d0e5b.svg";